import React from 'react';
import _ from 'lodash';
import Select from 'react-select'
import Spin from '../../../commonModules/interface/Spin';
import { FormDialog } from '../../../commonModules/interface/Dialog';
import { IconButton, Box, Grid, Button } from '@material-ui/core';
import { VisibilityRounded } from '@material-ui/icons';
import InputText, { InputSelect, InputSelectNative, TextArea } from '../../../commonModules/interface/form-input-inline';
import NewFormRegestering from '../module/NewFormRegestering';
import PopUp from '../../../commonModules/interface/PopUp';

const sendTech = [
    "En attente",
    "En attente de validation",
    "Visite recouvrement en attente",
    "Désinstallation en attente",
]

class EditForm extends React.PureComponent {
    state = {
        toAttribute: false,
        status: '',
        statusDisplay: '',
        comment: '',
        pb: '',
        technician: null,
        installatorlist: [],
        // schemasList: [],
        actions:[],
        action:'',
        popupSchema: false,
        // dateIntervention:"",
        price:"",
        nb_km:"",
        questionnaireID:"",
        errors:{
            pb:false,
            technician:false,
            comment:false,
            status:false,
            questionnaireID:false,
        },
        loading:false
        
    };
    componentDidMount = async() => {
        var methodName = "componentDidMount / EditForm"
        console.log('===========PROPS STATUS================');
        console.log(this.props.status);
        console.log('====================================');
        if (sendTech.includes(this.props.status)) {
            this.setState({ toAttribute: true });
            try {
                const response = await fetch('/installer/list', {
                method: 'GET',
                headers: {
                   'Content-Type': 'application/json',
                   // 'X-Requested-With': 'XMLHttpRequest',
                   //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                credentials: 'same-origin',                    
                });            
                const resp = await response.json();
                console.log(resp);

                var optionTmp = [];
                optionTmp.push({id: "", idobj: "none"})
                try {
                    var data = resp; //var data = JSON.parse(result);
                    for (var i = 0; i < data.contentJs.length; i += 1) {
                        optionTmp.push({id: data.contentJs[i].name, idobj: data.contentJs[i].id})
                    }
                } catch (e) {
                    // les instructions utilisées pour gérer les
                    // exceptions
                    console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                    console.log(e); // on transfère l'objet de l'exception à une méthode
                    return;
                }
                console.log("[SUCESS], received installater list sucessfully", optionTmp);
                this.setState({ installatorlist: optionTmp });
                // this.getTechSchemas()
            } catch (err) {
                console.log("[ERROR], getting prospect data",err)
            }
        }
    }
    
    updateRequest = async (action, report) => {
        try {
            const { boxOwnersIds } = this.props;
            const { technician, comment, pb, questionnaireID, price, nb_km } = this.state;
            let content = {};
            if (action === 'attributeToTechTeam') {
                content = {
                    clientID: boxOwnersIds[report.paygoId] || report.paygoId ,
                    maintenanceID: report.id,
                    action,
                    technicianID: technician.id,
                    comment:pb,
                    schemaIDList:[questionnaireID],
                    nb_km,
                    price,
                };
                console.log({content}, {boxOwnersIds});
                
                // this.updateRequest('updateComment', report)
            } else if (action === 'updateComment' || action === 'close' || action === "deleteTech") {
                content = {
                    maintenanceID: report.id,
                    action,
                    comment,
                }
            } 
            const response = await fetch('/maintenance/updateReport', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                body: JSON.stringify(content),
                credentials: 'same-origin',
            });
            const res = await response.json();
            console.log('====================================');
            console.log("SUBMIT REPORT res", res);
            console.log('====================================');
            if (!res.error && res.statusCode === 200){
                return res.body;
            } else {
                return {}
            }
        } catch (err) {
            console.log(err);
            return err
        }
    }
    validate = () => {

        let action = this.state.action;
        let must = []
        let errors = {}
        let hasError = false
        switch (action){
            case 'attributeToTechTeam':
                must.push('questionnaireID','pb','technician')
                break;
            case 'updateComment':
            case 'standby':
                must.push('comment')
                break;
            case 'close':
                must.push('status')
                break;
        }
        console.log("[VALIDATE], must",must);
        
        must.map( field => {
            if (!this.state[field]) {
                console.log("[ERROR] ", field, " can't be empty");
                errors[field] = true
                hasError = true
            } else {
                errors[field] = false
            }
        }, this.setState({errors})  )
        if(hasError){
            return false
        }
        return true
    }
    
    createNewReportList = async () => {
        const { action, status, technician, nb_km, price, pb, comment} = this.state;
        let currentReport = Object.assign({}, this.props.selected_report)
        const response = await this.updateRequest( action, currentReport);
        
        console.log('createNewReportList response ', response);

        if (!response.id) {
            console.log('====================================');
            console.log("ERROR updateReport", response);
            console.log('====================================');
            this.props.setMessage({
                title:"Erreur!", 
                type:"danger", 
                message:"Un Problème est survenu",
                display:"fadeInDown"
            })
            return currentReport
        } else if (action === 'attributeToTechTeam') {
            console.log('Attributing report to technician... ', technician);

            this.props.setMessage({
                title:"Succès!", 
                type:"success", 
                message:"La panne a été envoyée au Technicien",
                display:"fadeInDown"
            });
        } else if (action === 'close' || action === 'standby') {
            console.log('Closing report...');

            this.props.setMessage({
                title:"Succès!", 
                type:"success", 
                message:"Le statut de la panne a été modifié",
                display:"fadeInDown"
            });
        } else if (action === "updateComment") {
            console.log('Adding comment to report...', comment);
            this.props.setMessage({
                title:"Succès!", 
                type:"success", 
                message:"Votre commentaire a été ajouté",
                display:"fadeInDown"
            });

        } else if (action === "deleteTech") {
            console.log('delete Tech ', comment);

            this.props.setMessage({
                title:"Succès!", 
                type:"success", 
                message:"L'attribution au technicien a été annulée",
                display:"fadeInDown"
            });

        }
        return response;   
    }
    
    handleChangeInt = (e) => {
        const field = e.target.name
        const value = e.target.value
        const regex = /^[0-9\b]+$/ // int only
        if(value ==="" || regex.test(value)){
            this.setState({
                [field]: parseInt(value)
            })
        }
    }
    submit = async () => {

        // console.log(this.props.reportIDList);
        
        if (this.validate()){
            console.log('VALIDATE OKAYY');

            let updated_item = await this.createNewReportList();
            
            this.props.onEdition(updated_item);
        }
        this.setState({
            loading:false
        })
    }
    setActions = e => {
        let value = e.target.value;
        let name = e.target.name;
        console.log('LABEL : ', value);
        const tmpActions = this.state[name];
        const idx = tmpActions.indexOf(value);
        console.log('BEFORE ADD/DELETE : ', tmpActions);
        if (idx !== -1) {
            tmpActions.splice(idx, 1);
        } else {
            tmpActions.push(value);
        }
        console.log('AFTER ADD/DELETE : ', tmpActions);
        this.setState({ [name]: tmpActions });
    }
    
    render() {
        console.log("STATE STATE", this.state);
        let status = [
            // {value:"", label: "Choisissez une action *"}, 
            {value:"updateComment", label: "Ajouter un Commentaire"}, 
        ];
        
        sendTech.includes(this.props.status) && status.push({value:'attributeToTechTeam', label: "Attribuer à un Technicien"})
        
        this.props.status !== 'Résolu' && status.push({value:"close", label: "Changer le statut"})
        this.props.status === 'En cours de traitement' && status.push({value:"deleteTech", label: "Annuler l'attribution au technicien"})
        // this.props.status === 'En attente de validation' && status.push({value:"standby", label: "Mettre en stand By"})

        return (
            <PopUp
                title={this.props.selected_report.Nom}
                close={this.props.handleClose}
                maxWidth="sm"
                submitAction={this.state.action !== "" && (() => this.setState({loading:true}, this.submit))}
            >
                <Box p={1}> 
                {/* <Box className="lv-message text-center">  */}
                    {this.state.loading && <Spin />}    
    
                    {this.state.questionnaireID && this.state.showQuest &&
                        <FormDialog 
                            ID={this.state.questionnaireID} 
                            close={()=>this.setState({ showQuest: false }) }
                        />
                    }
                    {this.state.popupSchema &&
                        <NewFormRegestering  
                            popupState={this.state.popupSchema} 
                            onCloseOverlay={() => this.setState({popupSchema: false})} 
                            report={true} 
                            fetchSchemas={this.props.getTechSchemas}
                        />
                    }
    
                    <Grid container>
                        <Grid item xs={12}>
                            <InputSelect
                                options={status}
                                placeholder="Séléctionner une action"
                                value={this.state.action || {value:"", label:""}}
                                onChange={(option) =>
                                    this.setState({ 
                                        action: option.value,
                                        statusDisplay: option,
                                        errors: {}
                                    }) 
                                }
                                label="Action"
                            />
                        </Grid>
                        { (this.state.action === 'close') && this.props.status !== 'Résolu' &&
                        <Grid item xs={12}>
                            <InputSelectNative
                                label="Nouveau statut"
                                required
                                options={[
                                    <option value="standby">Stand By</option>,
                                    <option>Résolu</option>
                                ]}
                                error={this.state.errors.status}
                                onChange={(e) => this.setState({ status: e.target.value })}
                            />
                        
                        </Grid>
                        }
                        { (this.state.installatorlist && sendTech.includes(this.props.status) && this.state.action === 'attributeToTechTeam') &&
                        
                        <>
                            <Grid item xs={12}>
                                <TextArea
                                    onChange={(e) => this.setState({ pb: e.target.value })}
                                    rows={3}
                                    label="Analyse du Problème"
                                    required
                                    value={this.state.pb}
                                    error={this.state.errors.pb}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputSelectNative
                                    label="Choisir un technicien"
                                    required
                                    error={this.state.errors.technician}
                                    onChange={(event) => {
                                        const selectedIndex = event.target.options.selectedIndex;
                                        console.log('event.target.options[selectedIndex] : ', event.target.options[selectedIndex].getAttribute('data-key'));
                                        if (event.target.value) {
                                            this.setState({ technician: { name: event.target.value, id: event.target.options[selectedIndex].getAttribute('data-key') } })
                                        } else {
                                            this.setState ({ technician: null });
                                        }
                                    }}
                                    options={ this.state.installatorlist.map(item =>
                                        <option key={item.idobj} data-key={item.idobj}>{item.id}</option>
                                        )
                                    }
                                />
                            </Grid>
    
                            <Grid item xs={12}>
                                <InputSelectNative
                                    error={this.state.errors.questionnaireID}
                                    options={this.props.schemasList.map(schema =>
                                        <option key={schema.id} value={schema.id}>
                                            {schema.name}
                                        </option>
                                    )}
                                    label="Questionnaire technicien"
                                    required
                                    onChange={(e) => this.setState({ questionnaireID: e.target.value }) }
                                />
                                <Box p={1}>
                                    <Button color="secondary" onClick={() => this.setState({popupSchema: true}) }>
                                        Créer un Formulaire
                                    </Button>
                                    {this.state.questionnaireID && 
                                        <IconButton 
                                            color="primary"
                                            title="Voir le Questionnaire"
                                            onClick={()=>this.setState({showQuest: true})}
                                        >
                                            <VisibilityRounded />
                                        </IconButton>
                                    }
                                </Box>
                            </Grid>
                            <Grid item xs={12}>
                                <InputText
                                    name="price"
                                    onChange={this.handleChangeInt }
                                    label="Prix de l'intervention"
                                    type="number"
                                    value={this.state.price}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <InputText
                                    name="nb_km"
                                    onChange={this.handleChangeInt }
                                    label="Nombre de Km Prévu"
                                    type="number"
                                    value={this.state.nb_km}
                                />
                            </Grid>
                        </>
                    }
                    
                    {/* reattribute to other tech */}
                    {this.state.installatorlist && this.state.action === 'attributeToTechTeam' && this.props.status === "En cours de traitement" &&
                        <Grid item xs={12}>
                            <InputSelectNative
                                label="Choisir un technicien"
                                required
                                error={this.state.errors.technician}
                                onChange={(event) => {
                                    const selectedIndex = event.target.options.selectedIndex;
                                    console.log('event.target.options[selectedIndex] : ', event.target.options[selectedIndex].getAttribute('data-key'));
                                    if (event.target.value) {
                                        this.setState({ technician: { name: event.target.value, id: event.target.options[selectedIndex].getAttribute('data-key') } })
                                    } else {
                                        this.setState ({ technician: null });
                                    }
                                }}
                                options={ this.state.installatorlist.map(item =>
                                    <option key={item.idobj} data-key={item.idobj}>{item.id}</option>
                                    )
                                }
                            />
                        </Grid>
                    }
                    {(this.state.action === 'standby' || this.state.action === 'updateComment' || this.state.action === 'close') &&
                    <Grid item xs={12}>
                        <TextArea
                            onChange={(e) => this.setState({ comment: e.target.value })}
                            rows={3}
                            label="Commentaire"
                            // required
                            value={this.state.comment}
                            error={this.state.errors.comment}
                        />
                    </Grid>
                    }
                    </Grid>                
                    
                    {/* {this.state.action !== "" &&
                        <Box p={1}>
                            <Button
                                onClick={() => {this.setState({loading:true}, this.submit)}}
                                // className="btn bgm-cyan waves-effect"
                                variant="contained"
                                color="secondary"
                            >
                                Valider
                            </Button>
                        </Box>
                    } */}
                </Box>
            
            </PopUp>
        );
    }
}

export default EditForm;